import $ from 'jquery'

export default class Step {
  number

  configurator

  $container

  $content

  $expander

  $inputs

  $selectionLabel

  constructor(container, i, parent) {
    this.number = i
    this.configurator = parent
    this.$container = $(container)
    this.$content = this.$container.find('.configurator-options__content')
    this.$expander = this.$container.find('.configurator-options__expander')
    this.$select = this.$container.find('select')
    this.$selectionLabel = this.$container.find(
      '.configurator-options__selection',
    )
    this.$options = this.$container.find('.configurator-option')

    this.$options.click((e) => {
      e.preventDefault()
      this.$select.val($(e.currentTarget).data('value')).trigger('change')
    })

    this.$expander.click((e) => {
      e.preventDefault()
      this.$content.slideToggle()
    })

    this.$select.change(() => this.updateSelection())
    this.updateSelection()
  }

  getSelection() {
    return this.$select.val() ? this.$select : null
  }

  expand() {
    this.$content.slideDown()
  }

  updateSelection() {
    const $selection = this.getSelection()

    if (!$selection) {
      this.$selectionLabel.empty()
      this.configurator.updateSelection(this, this.$select.attr('name'), false)
    } else {
      const $option = $selection.find('option:selected')

      this.$selectionLabel.text($option.data('name'))
      this.$content.slideUp()
      this.configurator.updateSelection(
        this,
        $selection.attr('name'),
        $selection.val(),
      )
      this.configurator.expandStep()
    }

    this.$options.each((i, option) => {
      $(option).toggleClass(
        'configurator-option--active',
        this.$select.val() === $(option).data('value').toString(),
      )
    })
  }
}
